import {
  findContentfulFlagValue,
  getMobileAndDesktopFirstImage,
  getMobileAndDesktopFirstVideo,
} from '../utils';
import { HeroV3BulletPoint, HeroV3Props } from './HeroV3';

export function parseHeroV3(
  section: Queries.ContentfulSection001,
): HeroV3Props {
  const { eyebrow, metadata, images } = section || {};
  const { title, ctas, context, theme, flags, description } = metadata || {};

  const hideClipPath = findContentfulFlagValue('hideClipPath', flags);

  const eyebrowIcon = images?.find((image) => {
    const flags = image?.metadata?.flags;

    return findContentfulFlagValue('isEyebrowIcon', flags);
  });

  const subsections = section?.subsections as Queries.ContentfulSection001[];

  const bulletPoints: HeroV3BulletPoint[] = subsections
    ? subsections?.map((subsection: Queries.ContentfulSection001) => {
        const { metadata: subSectionMetadata } = subsection || {};
        const { title, context, theme } = subSectionMetadata || {};

        return {
          text: title,
          iconName: context?.icon,
          textColor: theme?.textColor,
          iconColor: theme?.secondaryColor,
        };
      })
    : [];

  const sectionImages = getMobileAndDesktopFirstImage(images);
  const sectionVideo = getMobileAndDesktopFirstVideo(images);

  return {
    eyebrow: eyebrow,
    eyebrowColor: theme?.secondaryColor,
    title: title,
    titleColor: theme?.primaryColor,
    backgroundColor: theme?.backgroundColor,
    titleTag: context?.titleTag,
    bulletPoints: bulletPoints,
    desktopImage: sectionImages.desktopImage,
    mobileImage: sectionImages.mobileImage,
    cta: ctas ? ctas[0] : null,
    hideClipPath: hideClipPath ?? false,
    eyebrowIcon: eyebrowIcon?.desktopImage,
    disclaimer: description?.childMarkdownRemark?.html,
    disclaimerColor: theme?.tertiaryColor,
    mobileVideo: sectionVideo.mobileVideo,
    desktopVideo: sectionVideo.desktopVideo,
  };
}
